import {consultationService} from "../service/consultation";
import {isEmpty, pickByArray, pickByObject} from "../utils";
import {REFERRAL_TYPE} from "../config";
import {referralOrderCache} from "../cache/ReferralOrder";

export const consultationMixin = {
  methods: {
    getConsultationActionMap() {
      return new Map([
        ['发起会诊', () => {
          this.$router.push('/main/consultation/apply');
        }],
        ['会诊单打印', (order) => {
          //this.$refs.printDialog.show(order);
          this.$router.push(`/main/consultation/report/${order.id}`);
        }],
        ['详情', (order) => {
          const {meta} = this.$route;
          this.$router.push({
            path: '/main/consultation/detail/' + order.id,
            query: {type: meta.type}
          });
        }],
        ['提交申请', async (form) => {
          const {doc} = this.loginInfo;
          let vailCount = 0;
          ['base', 'history', 'apply'].forEach(r => {
            if (!this.$refs[`${r}Form`].getForm().vail) {
              return;
            }
            vailCount++;
            let data = this.$refs[`${r}Form`].getForm().form;
            form = {...form, ...data};
          });
          if (vailCount != 3) return
          let historyForm = this.$refs.historyForm.getForm().form;
          let ret = null;
          if (doc.docType === 'DOC') {
            form.acceptDocId = form.hopeDocId;
            form.acceptDeptId = form.hopeDeptId;
            form.acceptHosId = form.hopeHosId;
            form.initDocId = form.applyDocId;
            form.consulterGender = form.sex;
            form.consulterAge = form.age;
            ret = await consultationService.docIssue(form)
          } else {
            form.acceptDocId = form.hopeDocId;
            form.acceptDeptId = form.hopeDeptId;
            form.acceptHosId = form.hopeHosId;
            //医助申请时新增参数acceptDocId acceptDeptId acceptHosId
            form.initAssId = doc.id;
            form.initDocId = form.applyDocId;
            ret = await consultationService.assIssue(form);
          }
          if (ret !== false && ret.id) {
            await consultationService.perfect({
              consultId: ret.id,
              ...historyForm
            });
            this.$message.success('提交成功');
            this.$cache.set('consultationOrderCache', null);
            this.$router.back();
          }
        }],
        ['取消申请', (order) => {
          this.$confirm('接收方医院正在为您安排会诊,您确定取消这次的会诊申请吗？', '提示', {
            confirmButtonText: '取消申请',
            cancelButtonText: '再等一等',
            type: 'warning'
          }).then(() => {
            this.$refs['detail_dialog'].start('cancle');
          }).catch(() => {

          });
          // this.$prompt('本次会诊未开始，是否确定取消？', '提示', {
          //   confirmButtonText: '确定取消',
          //   cancelButtonText: '再想想',
          //   inputType: 'textarea',
          //   inputPlaceholder: '请输入取消原因',
          //   inputErrorMessage: '拒绝理由不能为空',
          //   inputValidator: (value) => {
          //     return !isEmpty(value);
          //   },
          // }).then(async ({value}) => {
          //   if (await consultationService.cancel({
          //     consultId: order.id,
          //     disagreeReason: value
          //   })) {
          //     this.$message({
          //       message: '成功取消申请',
          //       type: 'success'
          //     });
          //     bus.$emit('top0', 0);
          //     if (this.getDetail) this.getDetail();
          //   }
          // }).catch(() => {
          //
          // });
        }],
        ['取消会诊', (order) => {
          this.$confirm('您确定取消这次的会诊安排吗？', '提示', {
            confirmButtonText: '取消会诊',
            cancelButtonText: '再等一等',
            type: 'warning'
          }).then(() => {
            this.$refs['detail_dialog'].start('cancle');
          }).catch(() => {

          });
        }],
        ['更改会诊时间', (order) => {
          this.$refs['detail_dialog'].start('update');
        }],
        ['再次申请', async order => {
          this.$cache.set('consultationOrderCache', this.info);
          this.$router.push({
            path: '/main/consultation/apply', query: {
              again: true
            }
          });
        }],
        ['提交', (order) => {
          let data = this.$refs.checkForm.getForm();
          this.doConsultationAction(data.action, {...data, id: order.id});
        }],
        ['安排会诊', async (order) => {
          if (!order.date || !order.time) return this.$message.error('请选择会诊日期和时间');
          const consultTime = order.date + ' ' + order.time;
          if (new Date(consultTime.replace(/-/g, '/')).getTime() < Date.now()) return this.$message.error('安排时间要大于当前时间');
          if (await consultationService.process({
            consultId: order.id,
            acceptDocId: order.acceptDocId,
            remark: order.remark,
            consultTime
          })) {
            this.$message({
              message: '安排会诊成功',
              type: 'success'
            });
            this.$router.back();
          }
        }],
        ['资料缺失', async (order) => {
          if (await consultationService.askperfect({
            consultId: order.id,
            perfectReason: order.perfectReason
          })) {
            this.$notify.success({
              title: '提示',
              message: '处理成功'
            });
            this.$router.back();
          }
        }],
        ['确认补充', async order => {
          const data = this.$refs.historyForm.getForm();
          const form = {
            ...pickByArray(data, ['consultContent', 'consultReason', 'beforeDiagnose', 'attaIdList', 'picList']),
            consultId: order.id
          };
          if (await consultationService.perfect(form)) {
            this.$message({
              message: '资料补充成功',
              type: 'success'
            });
            bus.$emit('top0', 0);
            if (this.getDetail) this.getDetail();
          }
        }],
        ['拒绝会诊', async (order) => {
          if (!order.disagreeReason) return this.$message.error('请填写拒绝理由');
          if (await consultationService.refuse({
            consultId: order.id,
            disagreeReason: order.disagreeReason
          })) {
            this.$message({
              message: '会诊已拒绝',
              type: 'success'
            });
            this.$router.back();
          }
        }],
        ['完成会诊', async (order) => {
          this.$confirm('点击确定后无法再次进入视频', '本次会诊已顺利完成，是否确定结束？', {
            confirmButtonText: '确定结束',
            cancelButtonText: '再想想',
          }).then(async () => {
            if (await consultationService.complete(order.id)) {
              this.$message({
                message: '会诊已结束',
                type: 'success'
              });
              bus.$emit('top0', 0);
              if (this.getDetail) this.getDetail();
            }
          });
        }],
        ['提交会诊情况', async order => {
          let data = this.$refs.resultForm.getForm();
          if (isEmpty(data.consultAdvice) || isEmpty(data.afterDiagnose)) return this.$message.error('咨询意见或会诊意见不能为空!');
          data.transfer = data.transferStr === '是' ? true : false;
          if (await consultationService.advice({...data, consultId: order.id})) {
            this.$message({
              message: '会诊情况已提交',
              type: 'success'
            });
            bus.$emit('top0', 0);
            if (this.getDetail) this.getDetail();
          }
        }],
        ['评价', () => {
          this.$refs.commentDialog.show();
        }],
        ['确定评价', async (order) => {
          if (order.equalDiagnose) {
            order.equalDiagnose = order.equalDiagnose === '符合' ? true : false;
          }
          let ret;
          if (order.type === 'accept') {
            ret = await consultationService.advice(order)
          } else {
            ret = await consultationService.comment(order);
          }
          if (ret) {
            this.$notify.success({
              title: '提示',
              message: '会诊已评价'
            });
            bus.$emit('top0', 0);
            if (this.getDetail) this.getDetail();
          }
        }],
        ['进入诊间', async (order) => {
          this.id = order.id;
          this.$router.push({
            path: '/other/ychz/fullscreen',
            query: {id: order.id}
          })
          /*const {room = {}} = await consultationService.intovideo(order.id);
          this.room = room;
          if (!isEmpty(room)) this.$refs.videoDialog.show(room);*/

        }],
        ['申请转诊', data => {
          if (data.method && data.method === 'post') {
            const type = REFERRAL_TYPE.find(r => r.name === data.type);
            bus.$emit('top0');
            referralOrderCache.set(pickByObject(data.data, {
              age: 'age',
              sex: 'sex',
              patName: 'consulterName',
              patIdcard: 'consulterIdcard',
              patMobile: 'consulterMobile',
              patInhosno: 'consulterInhosno',
              areaCode: 'consulterAreaCode',
              address: 'consulterAddress',
              patJob: 'consulterJob'
            }));
            setTimeout(() => {
              this.$router.push(`/main/referral/${type.id}/apply?from=consultation`);
            }, 0);
          } else this.$refs.referralDialog.show();
        }],
        ['确定上传', async (data) => {
          let form = this.$refs['historyform'].getForm();
          if (await consultationService.perfect({
            consultId: this.consultId,
            ...form
          })) {
            this.$message({
              message: '补充资料提交成功。',
              type: 'success'
            });
            this.getDetail();
          }
        }],
        ['已提交会诊情况', () => {
          this.$message({
            message: '您已提交过会诊情况',
            type: 'warning'
          });
        }],
        ['视频回放', async (order) => {
          let obj = await consultationService.getVideos(order.id);
          this.$refs['backVideo'].show(obj);
        }]
      ]);
    },
    doConsultationAction(name, data) {
      const map = this.getConsultationActionMap();
      const action = [...map].find(r => r[0] === name);
      if (isEmpty(action)) this.$message.error(`未定义 ${name} 操作`);
      else action[1](data);
    }
  },
}
